// extracted by mini-css-extract-plugin
export default {"firstSessionModal_container":"Br","firstSessionModal_header":"Cr","firstSessionModal_title":"Er","firstSessionModal_header_tex":"Fr","firstSessionModal_video":"Gr","firstSessionModal_videoContent":"Hr","firstSessionModal_FAQ":"Ir","firstSessionModal_FAQMargin":"Jr","firstSessionModal_FAQTitle":"Kr","firstSessionModal_buttonContainer":"Lr","firstSessionModal_buttonText":"Mr","firstSessionModal_SMSBtn_mob":"Nr"};
    if(module.hot) {
      // 1711394575976
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  